module.exports = __webpack_public_path__ + "img/cash-on-pickup.cc33da83.png";